var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderHistoryInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 78,
    viewBox: "0 0 80 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 42.5C76 62.1061 60.1061 78 40.5 78C20.8939 78 5 62.1061 5 42.5C5.15214 39.6093 5.6259 36.7764 6.38894 34.0507C6.76469 34.6285 7.25608 35.1449 7.85651 35.5632C9.33998 36.5964 11.1548 36.7975 12.7471 36.2655C12.3219 38.2717 12.1 40.3582 12.1 42.5C12.1 58.1849 24.8151 70.9 40.5 70.9C56.1849 70.9 68.9 58.1849 68.9 42.5C68.9 26.8151 56.1849 14.1 40.5 14.1C33.8756 14.1 27.9927 16.1495 23.3236 19.6178C23.0057 18.3912 22.2648 17.2678 21.1435 16.4869C20.1882 15.8215 19.0955 15.5012 18.0133 15.4995C24.0515 10.2391 31.8132 7 40.5 7C60.1061 7 76 22.8939 76 42.5Z",
    fill: "#728EBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.05L21 4.00002",
    stroke: "#728EBC",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38L10 34",
    stroke: "#728EBC",
    strokeWidth: 6.9,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3 63.6C52.0637 63.6 61.6 54.0637 61.6 42.3C61.6 30.5363 52.0637 21 40.3 21C28.5363 21 19 30.5363 19 42.3C19 54.0637 28.5363 63.6 40.3 63.6ZM46 34C46 31.7909 44.2091 30 42 30C39.7909 30 38 31.7909 38 34V42.3978C37.9639 42.4873 37.9308 42.5783 37.9009 42.6707L33.9271 47.4393C32.5129 49.1364 32.7422 51.6586 34.4393 53.0729C36.1364 54.4871 38.6586 54.2578 40.0729 52.5607L44.9387 46.7218C45.0261 46.6244 45.109 46.5229 45.1871 46.4175C45.3014 46.2671 45.4052 46.1083 45.4976 45.9423C45.4084 46.1024 45.3073 46.2581 45.194 46.4082C45.6973 45.7246 45.996 44.8812 46 43.9682C46 43.97 46 43.9718 46 43.9737V44C46 44.2553 45.9761 44.505 45.9304 44.747C45.9787 44.4912 46.0018 44.2322 46 43.9737V34Z",
    fill: "#728EBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderHistoryInactive);
export default __webpack_public_path__ + "static/media/order-history-inactive.302ea51901d0ff4c01cf4804c38315bd.svg";
export { ForwardRef as ReactComponent };